import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import React from "react";

export interface DropdownDetailsProps {
  handleTaskItemNameChange: (event: any) => void;
  name: string;
  options: FormOption[];
  onOptionAdd: (option: FormOption) => void;
  onOptionRemove: (option: FormOption) => void;
  onOptionEdit: (option: FormOption) => void;
}

export default function DropdownDetails({
  name,
  options,
  handleTaskItemNameChange,
  onOptionAdd,
  onOptionEdit,
  onOptionRemove,
}: DropdownDetailsProps) {
  const inputs: ConfigInput[] = [
    {
      required: true,
      title: "Prompt",
      type: "text",
      onChange: handleTaskItemNameChange,
      placeholder: "Provide a descriptive name",
      xs: 12,
      sm: 6,
      id: "taskItemName",
      value: name,
    },
    {
      title: "Add Dropdown Items",
      type: "addList",
      options: options,
      xs: 12,
      sm: 6,
      id: "addDropDownItems",
      onChange: () => {},
      onOptionAdd,
      onOptionEdit,
      onOptionRemove,
    },
  ];
  return (
    <ConfigForm title="Configure Dropdown Menu" inputs={inputs}></ConfigForm>
  );
}
